var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcRefresh = function SvgIcRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_refresh_svg__clip0_9491_113365)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.427 8.574a3.76 3.76 0 0 1 6.377-2.7l-.889.066a.75.75 0 1 0 .111 1.495l2.53-.187a.75.75 0 0 0 .684-.871l-.5-3a.75.75 0 1 0-1.48.246l.13.778a5.26 5.26 0 1 0 1.947 5.252.75.75 0 1 0-1.469-.306 3.762 3.762 0 0 1-7.442-.773Z"
  }))));
};
export default SvgIcRefresh;